import { LegalPage, LegalSection } from "./LegalLayout";
import { CONTACT, HOST } from "../content";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="JUNE 2026" testid="privacy-page">
      <LegalSection heading="1. Who We Are">
        <p>
          This Privacy Policy describes how {HOST.name} ({HOST.company}, NMLS# {HOST.nmls}, Company NMLS# {HOST.companyNmls}) ("we," "us," or "our") collects, uses, and protects your personal
          information when you visit this website, register for our educational webinar, request a review call, or
          communicate with us by phone, email, SMS/text message, or chat.
        </p>
      </LegalSection>
      <LegalSection heading="2. Information We Collect">
        <p>We may collect the following information when you voluntarily provide it:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Contact details: name, email address, mobile phone number, and state of residence</li>
          <li>Homebuying preferences you choose to share (e.g., your homebuying timeline or buyer track)</li>
          <li>Website analytics data: page URL, referring URL, campaign parameters (UTM), and general usage data</li>
          <li>Communication records, including chat, email, and SMS message history</li>
        </ul>
      </LegalSection>
      <LegalSection heading="3. How We Use Your Information">
        <ul className="list-disc pl-6 space-y-1">
          <li>To confirm and deliver your webinar registration and replay access</li>
          <li>To schedule and conduct the free VA Eligibility &amp; Pre-Approval Review you request</li>
          <li>To send transactional and informational messages you have consented to receive</li>
          <li>To improve this website and our educational content</li>
          <li>To comply with legal, licensing, and regulatory obligations</li>
        </ul>
      </LegalSection>
      <LegalSection heading="4. SMS / Text Messaging Program (A2P 10DLC Disclosure)">
        <p>
          By providing your mobile phone number and checking the consent box (or replying to opt in), you expressly
          consent to receive informational and conversational SMS/text messages from {HOST.name} / {HOST.company} related
          to your webinar registration, replay access, review call scheduling, and related educational content.
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong className="text-white">Message frequency varies.</strong> Message and data rates may apply.</li>
          <li>Reply <strong className="text-white">STOP</strong> at any time to cancel and opt out of all future messages.</li>
          <li>Reply <strong className="text-white">HELP</strong> for help, or contact us at {CONTACT.phone} or {CONTACT.email}.</li>
          <li>Consent to receive text messages is not a condition of any purchase or of obtaining any loan or service.</li>
          <li>Carriers are not liable for delayed or undelivered messages.</li>
        </ul>
        <p>
          <strong className="text-white">No mobile information will be shared with third parties or affiliates for
          marketing or promotional purposes.</strong> All the above categories exclude text messaging originator opt-in
          data and consent; this information will not be shared with, or sold to, any third parties.
        </p>
      </LegalSection>
      <LegalSection heading="5. Sharing of Information">
        <p>
          We do not sell your personal information. We may share information only with: (a) service providers who help
          us operate this website and our communications (e.g., CRM, email, and scheduling platforms) under
          confidentiality obligations; (b) regulators or law enforcement where required by law; and (c) with your
          direction, parties involved in a transaction you pursue. As stated above, SMS opt-in data and consent are
          never shared with or sold to third parties.
        </p>
      </LegalSection>
      <LegalSection heading="6. Data Security & Retention">
        <p>
          We use commercially reasonable administrative, technical, and physical safeguards to protect your
          information, and we retain it only as long as needed for the purposes described here or as required by
          applicable law and licensing regulations.
        </p>
      </LegalSection>
      <LegalSection heading="7. Your Choices & Rights">
        <ul className="list-disc pl-6 space-y-1">
          <li>Opt out of SMS at any time by replying STOP to any message</li>
          <li>Unsubscribe from emails using the link in any email or by contacting us</li>
          <li>Request access to, correction of, or deletion of your personal information by emailing {CONTACT.email}</li>
        </ul>
      </LegalSection>
      <LegalSection heading="8. Children's Privacy">
        <p>This website is not directed to individuals under 18, and we do not knowingly collect information from them.</p>
      </LegalSection>
      <LegalSection heading="9. Changes & Contact">
        <p>
          We may update this Privacy Policy from time to time; the "Last Updated" date reflects the latest revision.
          Questions? Contact {HOST.name} at {CONTACT.phone} or {CONTACT.email}.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
